/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `it-IT`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `it-it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `Europe/Rome`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alertBar_dismiss = () => `Ignora il messaggio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_skipButton_skipContent = () => `Passa al contenuto principale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_currentSlide = () => `Slide attuale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_goToSlide = () => `Vai alla slide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `Tempo di lettura stimato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `in minuti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `Ultimo aggiornamento:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `Questo articolo è stato utile?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `Sì`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `No`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `Il tuo feedback è stato inviato. Grazie!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `Siamo felici ti sia stato utile!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `Usa questo modulo solo per il feedback sull'articolo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `Scopri come contattare l'assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Autorizzo Klaviyo a contattarmi in merito al feedback che ho inviato.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `Descrivi cosa stai cercando di fare, imparare o risolvere.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `Verifica che il tuo indirizzo e-mail includa una sola chiocciola (@), seguita da un dominio valido (nome@esempio.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `Grazie per la segnalazione. Dicci qualcosa di più sul problema.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `Ho bisogno di ulteriori dettagli o spiegazioni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `Non corrisponde alla mia ricerca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `Come potremmo migliorare questo articolo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `Descrivi cosa ti è piaciuto o come l'articolo potrebbe essere migliorato.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `Puoi fornirci qualche dettaglio in più?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `Invia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `Ti contatteremo solo in merito al feedback da te inserito su questo articolo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `nome@esempio.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `Poco chiaro, confuso o difficile da capire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `Non corrisponde all'esperienza del prodotto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_authorAltText = () => `Foto del profilo dell'autore`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_defaultAuthorAltText = () => `Immagine Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_minRead = () => `minuti di lettura`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_read = () => `Leggi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_days = () => `Giorni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_hours = () => `Ore`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_minutes = () => `Minuti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_seconds = () => `Secondi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_filterBlock_topic = () => `Argomento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_save = () => `Salva`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_saved = () => `Salvato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseDepartment_openRoles = () => `ruoli aperti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_previous = () => `Precedente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_next = () => `Seguente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_relatedCard_openInANewTab = () => `si apre in una nuova scheda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `Cerca per argomento o parola chiave`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articlesPlural = () => `articoli`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articleSingular = () => `articolo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `Esci dall'Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `Le mie risorse Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_href = () => `/it-it/profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `Accedi all'Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `Contattaci (EN) ↗`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `Account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `Accedi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `Cerca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_anchorLinks_backToTop = () => `Torna in alto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_tableContents = () => `Indice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogArticleHero_featureImageAltText = () => `Immagine in evidenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewCategory = () => `Visualizza categoria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_title = () => `L'approccio di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_tagline = () => `La tua risorsa di marketing personale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_days = () => `Giorni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_hours = () => `Ore`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_minutes = () => `Minuti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_seconds = () => `Secondi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Primi passi con Klaviyo (EN) ↗`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `Scopri come integrare il tuo negozio online e iniziare a inviare i messaggi con Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `Come configurare gli SMS in Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `Centro assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `Impara a inviare efficacemente gli SMS con Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/it-it/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `Come creare e inviare una campagna email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `Centro assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `Crea e invia la tua prima campagna e-mail.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/it-it/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `Primi passi con i moduli di iscrizione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `Centro assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `Utilizza i moduli per interagire con i tuoi iscritti e raccogliere maggiori informazioni su di loro.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/it-it/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `Come utilizzare l'intelligenza artificiale per creare un flusso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `Centro assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `Crea un flusso completo su larga scala utilizzando gli input in linguaggio naturale.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/it-it/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `Primi passi con le recensioni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `Centro assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `Raccogli i feedback dei clienti e contribuisci a incrementare le conversioni.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/it-it/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `Carica altro`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Copyright © ${params.year} Klaviyo. Tutti i diritti riservati.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `Le tue impostazioni di privacy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `Richiedi una demo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `Richiedi una demo personalizzata`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Scopri come Klaviyo può contribuire alla crescita della tua azienda con una presentazione dei prodotti e una consulenza.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `Tutti i campi sono obbligatori`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `Richiedi una demo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `Invio in corso...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `È tutto pronto.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `Esplora tutte le funzionalità`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `Consulta le risorse di marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_headline = () => `Inizia oggi stesso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_body = () => `Invia la tua prima campagna marketing in pochi minuti e metti il pilota automatico grazie a messaggi SMS ed e-mail mirati che si convertiranno in vendite.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_button = () => `Crea un account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_buttonSubmitting = () => `Invio in corso...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_label = () => `Informativa sulla privacy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_href = () => `/legal/privacy/privacy-notice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService = () => `Termini di servizio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_acknowledgement = () => `Inviando questo modulo, accetti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService_href = () => `/legal/terms-of-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_and = () => `e`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_network = () => `La richiesta non è andata a buon fine a causa di un errore di rete. Riprova.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_generic = () => `La tua richiesta non è andata a buon fine. Riprova.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_rateLimit = () => `Hai effettuato troppi accessi in un breve periodo di tempo. Usa i tuoi account esistenti o contatta l'assistenza clienti per ulteriore aiuto. Grazie.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_recaptcha = () => `reCaptcha obbligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_label = () => `Nome`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_placeholder = () => `Nome completo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_errors_required = () => `Inserisci il tuo nome`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_label = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_placeholder = () => `nome@esempio.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_email = () => `Verifica che il tuo indirizzo e-mail includa una sola chiocciola (@), seguita da un dominio valido (nome@esempio.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_required = () => `Obbligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_label = () => `Password`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_placeholder = () => `Inserisci la password`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_common = () => `La tua password è troppo semplice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_min = () => `La password deve contenere almeno 8 caratteri.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_max = () => `La password può avere al massimo 128 caratteri.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_required = () => `Obbligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_label = () => `Nome dell'azienda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_placeholder = () => `Inserisci il nome della tua azienda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_errors_required = () => `Inserisci il nome della tua azienda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_label = () => `Sito web dell'azienda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_placeholder = () => `https://example.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_url = () => `Il sito web dell'azienda deve includere un dominio valido (https://esempio.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_required = () => `Obbligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_label = () => `Numero di telefono`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_placeholder = () => `Inserisci il tuo numero di telefono`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_matches = () => `Il numero di telefono deve includere il prefisso locale o internazionale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_max = () => `Il numero può essere composto da un massimo di 15 caratteri`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_required = () => `Obbligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_label = () => `Fatturato annuo stimato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_placeholder = () => `Seleziona il fatturato annuo stimato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_underFive = () => `Meno di 5 milioni di dollari`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_five = () => `5 - 20 milioni di dollari`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_twenty = () => `20 - 400 milioni di dollari`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_fourHundred = () => `Oltre 400 milioni di dollari`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_errors_required = () => `Seleziona il fatturato annuo stimato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_label = () => `Come intendi utilizzare Klaviyo?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_placeholder = () => `Seleziona l'utilizzo che intendi fare di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_ownBusiness = () => `Per la mia attività`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_clientsBusiness = () => `Per l'attività dei miei clienti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_errors_required = () => `Seleziona l'utilizzo che intendi fare di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_label = () => `Tipo di attività`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_placeholder = () => `Seleziona il tipo di attività`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailGoods = () => `Beni al dettaglio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailServices = () => `Servizi al dettaglio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_other = () => `Altro, prodotti e servizi non al dettaglio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_errors_required = () => `Seleziona il tipo di attività`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_label = () => `Numero di contatti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_placeholder = () => `Seleziona il numero di contatti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_zero = () => `0 - 1000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_one = () => `1000 - 3000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_three = () => `3000 - 25.000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_twentyFive = () => `25.000 - 100.000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneHundred = () => `100.000 - 500.000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_fiveHundred = () => `500.000 - 1.000.000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneMillion = () => `Oltre 1.000.000`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_errors_required = () => `Obbligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_label = () => `Quali prodotti ti interessano? Seleziona tutte le opzioni pertinenti.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_placeholder = () => `Seleziona prodotti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_reviews = () => `Recensioni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_mobile_push = () => `Notifiche push su mobile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_errors_required = () => `Seleziona un prodotto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_label = () => `Piattaforma di e-commerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_placeholder = () => `Seleziona la piattaforma`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Magento = () => `Adobe Commerce (Magento)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_BigCommerce = () => `BigCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Commercetools = () => `Commercetools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Nuvemshop = () => `Nuvemshop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_OpenCart = () => `OpenCart`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_PrestaShop = () => `PrestaShop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Salesforce = () => `Salesforce Commerce Cloud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopify = () => `Shopify`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_ShopifyPlus = () => `Shopify Plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopware = () => `Shopware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_SquareOnline = () => `Square Online`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Wix = () => `Wix Stores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_WooCommerce = () => `WooCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_other = () => `Piattaforma di e-commerce non in elenco`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_custom = () => `Ho una piattaforma personalizzata`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_doesNotApply = () => `Non pertinente alla mia attività`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_errors_required = () => `Seleziona un prodotto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_newsletter_label = () => `Iscriviti alle comunicazioni di marketing di Klaviyo per ricevere la nostra newsletter, articoli del blog, notizie sui prodotti, informazioni sui webinar, pubblicità mirata e altro ancora. Puoi annullare l'iscrizione alle e-mail di marketing tramite il link di annullamento dell'iscrizione presente nelle e-mail.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_agency_label = () => `Sono un'agenzia che esegue l'iscrizione a nome del cliente.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_demo_requested_label = () => `Vorrei una consulenza/dimostrazione dal vivo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `Guida`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/it-it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `Richiesta di accesso all'account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `Richiesta di accesso all'account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `Non riesci ad accedere al tuo account?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `Invia le informazioni al nostro team di assistenza: ti contatteremo a breve.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `Verifica che il tuo indirizzo email includa una sola chiocciola (@), seguita da un dominio valido (nome@esempio.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `Il sito web dell'azienda deve includere un dominio valido (https://esempio.com)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `Inserisci un indirizzo e-mail valido`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `Obbligatorio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `Problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `Seleziona un problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `Account disabilitato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `Password dimenticata`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `Domanda sulla fatturazione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_2_step_authentication = () => `Autenticazione a più fattori`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `Nuovo codice dispositivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `Aggiorna proprietario account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `nome`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `Inserisci il tuo nome completo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `Account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `Inserisci il nome del tuo account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `Indirizzo e-mail dell'account Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `Inserisci un indirizzo e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `URL del sito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `Inserisci l'URL del sito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `Per cosa hai bisogno di aiuto?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `Descrivi il problema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `Destinatari aggiuntivi (facoltativo)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `Inserisci un indirizzo e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ Aggiungi destinatario`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `Invia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `La tua richiesta è stata inviata`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `Il nostro team assistenza ti risponderà il prima possibile. Verrà inviata una risposta agli indirizzi e-mail che hai fornito.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `Vai alla home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `Passa a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `Cerca offerte di lavoro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `Tutte le sedi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `Cerca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `Tutti i sistemi sono funzionanti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `Grave interruzione del sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `Interruzione parziale del sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `Interruzione minore del servizio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `Interruzione minore del sistema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `Prestazioni del servizio di sistema ridotte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `Prestazioni del sistema parzialmente ridotte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `Prestazioni del servizio parzialmente ridotte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `Servizio in manutenzione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `Chiudi finestra`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `Connettiti con altre aziende simili, partner ed esperti di Klaviyo per trovare ispirazione, condividere approfondimenti e ottenere risposte a tutte le tue domande.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `Visita la community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_openInNewTab = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `Formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Partecipa a una sessione dal vivo con gli esperti di Klaviyo per conoscere le linee guida consigliate, scoprire come configurare le funzionalità chiave e altro ancora.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `Registrati ora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_openInNewTab = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `Assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `Accedi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_openInNewTab = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `Accedi all'assistenza tramite il tuo account.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `Assistenza via e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(prova gratuita e account a pagamento)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `Disponibile 24 ore su 24, 7 giorni su 7`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `Chat/assistente virtuale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `La disponibilità può variare in base alla località e al tipo di piano`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Vai alla home page di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Vai sulla pagina risorse L'acceleratore di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `Richiedi una demo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Novità sui prodotti Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `Leggi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Logo Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `Visualizza tutto`


export { organisms_post_filter_ResourceCategory } from "./en-US.js"

export { organisms_post_filter_ResourceCollection } from "./en-US.js"

export { organisms_post_filter_ResourceStage } from "./en-US.js"

export { organisms_post_filter_ResourceTopic } from "./en-US.js"

export { organisms_post_filter_search } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_eyebrow = () => `Stima il prezzo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_headline = () => `Quanti sono i tuoi profili attivi?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_startingAt = () => `A partire da`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_month = () => `mese`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts = () => `profili attivi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactLimitExceeded = () => `Limite di profili attivi superato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_signUp = () => `Registrati`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlyEmailSends = () => `invii di e-mail al mese`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlySmsMmsCredits = () => `crediti SMS/MMS al mese`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_opensAModal = () => `(si apre una finestra modale)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_mobilePush = () => `Notifiche push su dispositivo mobile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeCredits = () => `crediti SMS/MMS al mese gratuiti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_includesFees = () => `Include le tariffe applicabili per l'operatore SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_supportToScale = () => `Assistenza per far crescere la tua attività`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_onboarding = () => `Onboarding a 450 $ al mese`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_csm = () => `Customer Success Manager a 1500 $ al mese`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_emailAndChatSupport = () => `Assistenza via e-mail e chat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeSupport = () => `Assistenza via e-mail per i primi 60 giorni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_getADemo = () => `Richiedi una demo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plusSign = () => `+`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_copy = () => `Potenzia la tua strategia di marketing raggiungendo i clienti tramite e-mail e SMS.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_name = () => `E-mail e SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_copy = () => `Sali di livello nella tua strategia di e-mail marketing con una soluzione semplice e personalizzabile su larga scala.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_name = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_copy = () => `Ideale per muovere i primi passi e provare la piattaforma clienti di Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_name = () => `Gratis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_buttons_getDemo = () => `Richiedi una demo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_richTextBody = () => `Se hai più di 250.000 profili attivi, contatta il nostro team di vendita per trovare il piano più adatto alle tue esigenze.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_headline = () => `Parliamone!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_regionName = () => `Stati Uniti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntrySms = () => `SMS = 1 credito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntryMms = () => `MMS = 3 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_regionName = () => `Canada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntrySms = () => `SMS = 3 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntryMms = () => `MMS = 5 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_regionName = () => `Regno Unito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntrySms = () => `SMS = 5 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_regionName = () => `Australia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntrySms = () => `SMS = 4 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_regionName = () => `Nuova Zelanda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntrySms = () => `SMS = 10 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_regionName = () => `Irlanda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntrySms = () => `SMS = 9 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_regionName = () => `Italia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntrySms = () => `SMS = 7 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_regionName = () => `Francia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntrySms = () => `SMS = 7 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_regionName = () => `Germania`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntrySms = () => `SMS = 12 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_regionName = () => `Paesi Bassi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntrySms = () => `SMS = 12 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_regionName = () => `Portogallo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntrySms = () => `SMS = 3 crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntryMms = () => `MMS = n/a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_headline = () => `Crediti SMS/MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText1 = () => `Puoi utilizzare i tuoi crediti per SMS, MMS o entrambi.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText2 = () => `I messaggi SMS e MMS richiedono un numero diverso di crediti, in base alla posizione del destinatario.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AU = () => `Australia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AT = () => `Austria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BE = () => `Belgio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CA = () => `Canada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DK = () => `Danimarca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FR = () => `Francia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FI = () => `Finlandia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DE = () => `Germania`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IE = () => `Irlanda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IT = () => `Italia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NL = () => `Paesi Bassi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NZ = () => `Nuova Zelanda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NO = () => `Norvegia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BR = () => `Portogallo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_GB = () => `Regno Unito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_US = () => `Stati Uniti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_ES = () => `Spagna`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_SE = () => `Svezia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CH = () => `Svizzera`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sendTo = () => `Invia a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms = () => `MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_maxSends = () => `Numero massimo di invii`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePer = () => `Prezzo per`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credit = () => `credito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credits = () => `crediti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimer = () => `Include le tariffe dell'operatore stimate a`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimerEnd = () => `Il prezzo a SMS/MMS può variare in base alla lunghezza del messaggio.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_tileList_viewAll = () => `Visualizza tutto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_video_playVideo = () => `Riproduci video`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `Tutti gli aggiornamenti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `Comprimi tutto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `Cancella tutto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `Cerca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `Guarda il riepilogo trimestrale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `Argomento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `Tipo di rilascio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `Vantaggi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `Account e fatturazione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `Dati analitici`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `Pubblico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `Campagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `Deliverability e conformità`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `Flussi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `Integrazioni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `Notifiche push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `Recensioni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `Moduli d'iscrizione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `Prossimamente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `Disponibilità limitata`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `Rilascio graduale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `Disponibilità generale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `Pagina non trovata`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `Si pronuncia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `Non è quello che cercavi? Torna alla <a href="/email-marketing">pagina e-mail</a>, alla <a href="/sms-marketing">pagina SMS</a> oppure vai alla <a href="/">home page</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `Vai alla home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_pageTitle = () => `Cerca un lavoro | Opportunità professionali in Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_headline = () => `Cerca tra le offerte di lavoro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_recentJobs = () => `Visualizzazioni recenti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_savedJobs = () => `Posizioni salvate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_home = () => `Home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_searchJobs = () => `Cerca tra le offerte di lavoro`


/**
 * @param {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_searchResults = (params) => `Stai visualizzando <strong>${params.start}</strong> - <strong>${params.end}</strong> di <strong>${params.total}</strong> posizioni lavorative affini`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResults = () => `Spiacenti, non sono state trovate posizioni lavorative corrispondenti ai tuoi criteri.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResultsReset = () => `Prova altre modalità di ricerca o clicca per <a href="#" onclick="window.location.href='/careers/search-jobs'">vedere tutte le posizioni aperte</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_legend = () => `Filtra le offerte di lavoro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywords = () => `Parole chiave`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywordsPlaceholder = () => `Cerca tra le offerte di lavoro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_country = () => `Paese`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_location = () => `Sede`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_team = () => `Team`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_applyFilters = () => `Applica filtri`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_clearFilters = () => `Cancella filtri`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `Domanda con risposta`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `minuti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `minuto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `ore`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `ora`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `Cerca in tutte le risorse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `Cerca per argomento o parola chiave`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `Visualizza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `Principali risultati della ricerca`


/**
 * @param {{ ' y ': NonNullable<unknown>, ' x ': NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `Stai visualizzando ${params[' y ']} di ${params[' x ']}`


/**
 * @param {{ ' index ': NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `Visualizza tutti i risultati ${params[' index ']}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `Visualizza altro`


/**
 * @param {{ ' query ': NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `Nessun risultato trovato per "${params[' query ']}"`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `Controlla l'ortografia o prova con una ricerca diversa.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `Ricerche suggerite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Primi passi con Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `Primi passi con gli SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Primi passi con la customer data platform (CDP) di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `Primi passi con i moduli`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `Black Friday e Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Crea un calendario di contenuti in Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `Comprimi tutto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `Cancella tutto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `Risorsa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `Tutte le risorse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `Sviluppatori`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `Risorse di marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `Account e fatturazione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `Dati analitici`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `Pubblico`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `Campagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `Deliverability e conformità`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `E-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `Flussi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `Integrazioni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `Notifiche push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `Recensioni`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `Moduli d'iscrizione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_title = () => `Mappa del sito di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_header = () => `Categoria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_postsByThisAuthor = () => `Post dello stesso autore`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_openInANewTab = () => `apri in una nuova scheda`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_featured = () => `In evidenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_articles = () => `articoli`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_customer = () => `Cliente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_industry = () => `Settore`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_platform = () => `Piattaforma`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `Nota`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `Avviso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `Requisiti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Cerca tra le nostre risorse utili per trovare le risposte alle domande più frequenti. Sfoglia i nostri articoli, esplora il forum della community, scopri i corsi di formazione dal vivo o registrati e tanto altro ancora: impara a utilizzare Klaviyo e segui le linee guida consigliate.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `Richiesta di accesso all'account`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `Articolo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `Categoria`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `Sezione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `Cerca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `Risorse in evidenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/it-it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `Cosa possiamo aiutarti a trovare oggi?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Esplora altri contenuti di Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `Vai all'Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/hc/it-it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `Non trovato | Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `Risorse in evidenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Scopri tante guide formative, corsi e materiali per far crescere la tua attività con Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `Cerca per argomento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `Cerca per argomento`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `Articoli principali`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `Nessun risultato per`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `Prova una ricerca diversa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `Nessun risultato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `Sviluppatori`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `Risorse di marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `Visualizza tutto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_title = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_opengraphSiteName = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_metaDesc = () => `Scopri come far crescere la tua attività con Klaviyo. Scopri i nostri corsi, ottieni le certificazioni e leggi le guide pratiche per crescere insieme a Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_bestPractices = () => `Best practice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_collection = () => `Certificato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_course = () => `Corso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_lesson = () => `Lezione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_search = () => `Cerca`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registered = () => `Registrato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_completed = () => `Completato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_viewed = () => `Visualizzato`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_startingText = () => `In corso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_endingText = () => `completo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_label = () => `Vai all'Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_href = () => `/it-it`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_titleText = () => `Non trovato | Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_headline = () => `Accelera le relazioni digitali con Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_subhead = () => `Impara le strategie e le linee guida consigliate per massimizzare i ricavi e raggiungere i tuoi obiettivi aziendali.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_label = () => `Visualizza tutte le risorse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_href = () => `/it-it/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_headline = () => `Novità e contenuti in evidenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_subhead = () => `Dai un'occhiata alle lezioni, alle guide e ai corsi di formazione più recenti del nostro team di esperti globali.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_title = () => `Guide alle best practice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_excerpt = () => `Scopri le migliori strategie di marketing per aiutarti ad acquisire clienti, automatizzare il coinvolgimento e aumentare le vendite.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_label = () => `Visualizza le best practice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_href = () => `/it-it/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_title = () => `Klaviyo su YouTube`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_excerpt = () => `Guarda i video tutorial per suggerimenti rapidi e approfondimenti di esperti che ti aiuteranno a far crescere la tua attività con Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_label = () => `Visita la raccolta di contenuti su YouTube`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_href = () => `https://www.youtube.com/channel/UCLLurTBYufj95_5zTnJISnA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_title = () => `Anatomia di un flusso: la serie di benvenuto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_excerpt = () => `Crea una serie di benvenuto personalizzata e scopri le linee guida consigliate per creare forti connessioni con gli iscritti.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_label = () => `Inizia a imparare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_href = () => `/it-it/courses/anatomy-of-a-flow-welcome-series/1881997`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_headline = () => `Decidi in che modo ti piacerebbe imparare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_subhead = () => `Scegli tra varie opzioni in linea con i tuoi programmi e con il tuo stile di apprendimento.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_title = () => `Primi passi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_content = () => `<p>Segui le procedure guidate per iniziare a usare nuovi canali, funzionalità e prodotti.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_label = () => `Visualizza tutte le guide per iniziare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_href = () => `/it-it/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_title = () => `Best practice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_content = () => `<p>Fai crescere il tuo business e ottimizza il tuo marketing con le linee guida consigliate.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_label = () => `Visualizza tutte le best practice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_href = () => `/it-it/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_title = () => `Guide rapide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_content = () => `<p>Trova le risposte in meno di dieci minuti con guide pratiche lunghe una pagina.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_label = () => `Visualizza tutte le guide rapide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_href = () => `/it-it/search?select=Quick+guide|Under+10+minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_title = () => `Formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_content = () => `<p>Partecipa alle sessioni live con gli esperti Klaviyo e trova le risposte alle tue domande in tempo reale.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_label = () => `Visualizza tutti i corsi di formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_href = () => `/it-it/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_title = () => `Corsi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_content = () => `<p>Impara come applicare strategie di marketing efficaci al tuo business con approfondimenti on demand ed esempi pratici.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_label = () => `Visualizza tutti i corsi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_href = () => `/it-it/search?select=Course`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_title = () => `Certificati`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_content = () => `<p>Approfondisci diversi argomenti attraverso una serie di corsi. Mettiti alla prova con un esame finale per ottenere un attestato.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_label = () => `Vedi tutti i certificati`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_href = () => `/it-it/search?select=Certificate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_title = () => `Risorse consigliate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_label = () => `Visualizza tutte le risorse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_href = () => `/it-it/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_coursePath = () => `/it-it/courses/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_collectionPath = () => `/it-it/collections/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_title = () => `Inizia dalle basi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_label = () => `Visualizza tutte le guide per iniziare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_href = () => `/it-it/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_description = () => `Scopri come integrare il tuo ecosistema di e-commerce, raccogliere iscritti e iniziare a inviare messaggi con Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_divider = () => `falso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_href = () => `/it-it/courses/getting-started-with-klaviyo/1459179`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_pill = () => `Corso, Primi passi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_title = () => `Come iniziare a usare i moduli di iscrizione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_description = () => `Scopri cosa sono i segmenti, come crearli e come utilizzarli per inviare campagne di marketing più mirate.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_divider = () => `falso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_href = () => `/it-it/courses/getting-started-with-sms/1411601`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_pill = () => `Corso, Primi passi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_title = () => `Primi passi con i segmenti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_description = () => `Le tue campagne di Klaviyo hanno bisogno di spiccare il volo? Scopri i segreti di oltre 143mila brand nella sezione Primi passi con il corso Campagne.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_divider = () => `falso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_href = () => `/it-it/courses/getting-started-with-klaviyo-cdp/1759043`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_pill = () => `Primi passi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_title = () => `Primi passi con le campagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_description = () => `Impara le nozioni di base sui flussi, crea i tuoi primi flussi automatizzati in Klaviyo e segui le linee guida consigliate per aumentare le entrate.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_divider = () => `falso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_href = () => `/it-it/courses/develop-a-klaviyo-reviews-strategy/1630005`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_pill = () => `Primi passi, Corso`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_title = () => `Primi passi con i flussi`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_title = () => `Iscriviti a una sessione di formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_subhead = () => `Impara dal nostro team di specialisti dal vivo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_label = () => `Visualizza tutti i corsi di formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_href = () => `/it-it/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_description = () => `Scomponi la deliverability delle e-mail con strategie per accedere e migliorare le prestazioni.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_href = () => `https://www.bigmarker.com/klaviyo-customer-education/strategy-session-understand-email-deliverability`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_pill = () => `Formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_title = () => `Informazioni sulla deliverability delle e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_description = () => `Impara le basi del design per aumentare il traffico e le conversioni.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-Design-emails-that-convert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_pill = () => `Formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_title = () => `Progetta e-mail ad alta conversione`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_description = () => `Comprendi il valore del canale SMS e scopri come integrarlo nel tuo flusso di lavoro.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-SMS-marketing-strategy-North-America`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_pill = () => `Formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_title = () => `Strategia di marketing via SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_description = () => `Poni dal vivo le tue domande sulla strategia agli esperti di Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Office-hours-Getting-started-with-Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_pill = () => `Formazione dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_title = () => `Orari di ufficio`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_headline = () => `Cosa dicono i nostri clienti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_text = () => `Ecco qualche esempio. È sempre utile osservare quello che fanno gli esperti. Grazie ai corsi di formazione ho imparato a navigare e lavorare in Klaviyo <3`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_label = () => `Registrati per un training dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_href = () => `/it-it/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_size = () => `large`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_text = () => `Gli esempi concreti e le istruzioni passo dopo passo sono stati INCREDIBILI. Penso che i training di Klaviyo siano i migliori a cui abbia mai partecipato.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_label = () => `Registrati per un training dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_href = () => `/it-it/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_size = () => `small`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_text = () => `Energico, dritto al punto e conciso. Niente giri di parole inutili. Il training vale il tempo che gli ho dedicato, che è prezioso. Ottima dimostrazione!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_label = () => `Registrati per un training dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_href = () => `/it-it/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_size = () => `small`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_text = () => `Ho molto apprezzato i diversi speaker. Tutti si sono dimostrati preparati e in grado di offrire contenuti coinvolgenti. Mi sono piaciuti gli approfondimenti e penso che siano stati ben progettati.  Grazie Klaviyo! Alla fine della sessione avevo già mille idee in testa da provare con i miei clienti.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_label = () => `Registrati per un training dal vivo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_href = () => `/it-it/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_size = () => `large`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `Home`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `Cerca tutto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `Mappa del sito`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_eyebrow = () => `BFCM 2024 (Black Friday e Cyber Monday)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_thisBfcm = () => `questo BFCM (Black Friday e Cyber Monday)`


export { atoms_singleLineForm_primaryButton } from "./en-US.js"

export { atoms_singleLineForm_placeholderText } from "./en-US.js"

export { atoms_singleLineForm_error } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_logOut_href } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_signIn_href } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = () => `https://www.klaviyo.com/support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = () => `Assistenza`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headline = () => `Fai che ogni giorno conti`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iAm = () => `Sono`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iWantTo = () => `Desidero`


export { organisms_blogCards_viewAll } from "./en-US.js"

export { organisms_blogSearchHero_placeholder } from "./en-US.js"

export { organisms_blogSearchHero_customSearchHeadline } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_submit } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_loading } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_examplePrompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productLaunch } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productPromotion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productUpdate } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_storewideSale } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_announcement } from "./en-US.js"

export { organisms_moreCards_card1_icon_iconName } from "./en-US.js"

export { organisms_moreCards_card2_icon_iconName } from "./en-US.js"

export { organisms_moreCards_card3_icon_iconName } from "./en-US.js"

export { organisms_moreCards_card3_richText_template } from "./en-US.js"

export { organisms_navigationCategorySelection_viewAllButton_text } from "./en-US.js"

export { organisms_navigationCategorySelection_viewLessButton_text } from "./en-US.js"

export { organisms_post_filter_read_more } from "./en-US.js"

export { organisms_pricing_per_month } from "./en-US.js"

export { organisms_pricing_contactSales } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_recommended } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_smsSubText } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_mmsSubText } from "./en-US.js"

export { organisms_pricing_plans_email_per_month } from "./en-US.js"

export { organisms_pricing_plans_email_emails_label } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_top } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_bottom } from "./en-US.js"

export { organisms_pricing_plans_expandable_button } from "./en-US.js"

export { organisms_pricing_plans_collapsible_button } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_above250kContacts } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_below250Contacts } from "./en-US.js"

export { organisms_pricing_plans_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_platform_cdp_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_platform_cdp_subTextInfo } from "./en-US.js"

export { organisms_pricing_plans_platform_cdp_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_headline } from "./en-US.js"

export { organisms_pricing_contacts_slider_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_credits_slider_headline } from "./en-US.js"

export { organisms_pricing_credits_slider_subText } from "./en-US.js"

export { organisms_pricing_credits_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_calculator_headline } from "./en-US.js"

export { organisms_pricing_calculator_service_type } from "./en-US.js"

export { organisms_pricing_calculator_destination } from "./en-US.js"

export { organisms_pricing_calculator_sms_limit } from "./en-US.js"

export { organisms_pricing_calculator_mms_limit } from "./en-US.js"

export { organisms_pricing_calculator_pricePerSend } from "./en-US.js"

export { organisms_searchBar_placeholder_post } from "./en-US.js"

export { organisms_searchBar_placeholder_page } from "./en-US.js"

export { organisms_searchBar_placeholder_case_study } from "./en-US.js"

export { organisms_searchBar_placeholder_compare_page } from "./en-US.js"

export { organisms_searchBar_placeholder_marketing_resource } from "./en-US.js"

export { organisms_searchBar_placeholder_newsroom_article } from "./en-US.js"

export { organisms_searchBar_placeholder_partner_page } from "./en-US.js"

export { organisms_searchBar_placeholder_podcast_page } from "./en-US.js"

export { organisms_searchBar_placeholder_product_update } from "./en-US.js"

export { organisms_searchBar_placeholder_solutions_page } from "./en-US.js"

export { organisms_searchBar_placeholder_success_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_post } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_case_study } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_product_update } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_marketing_resource } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_newsroom_article } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_podcast_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_compare_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_partner_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_solutions_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_postType_success_page } from "./en-US.js"

export { pages_search_refinements_klaviyoHome_category } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { roiCalculator_results_headlineText } from "./en-US.js"

export { roiCalculator_results_revenuePerYear } from "./en-US.js"

export { roiCalculator_results_subHeadlineText } from "./en-US.js"

export { roiCalculator_results_newSubscribers } from "./en-US.js"

export { roiCalculator_results_campaigns } from "./en-US.js"

export { roiCalculator_results_automatedFlows } from "./en-US.js"

export { roiCalculator_results_signupText } from "./en-US.js"

export { roiCalculator_results_getStartedButton } from "./en-US.js"

export { roiCalculator_results_talkToSales } from "./en-US.js"

export { roiCalculator_results_invalidRoi } from "./en-US.js"

export { roiCalculator_results_freeTier } from "./en-US.js"

export { roiCalculator_form_brandText } from "./en-US.js"

export { roiCalculator_form_fieldsRequired } from "./en-US.js"

export { roiCalculator_form_channelsUsed } from "./en-US.js"

export { roiCalculator_form_toggleEmail } from "./en-US.js"

export { roiCalculator_form_toggleEmailAndSms } from "./en-US.js"

export { roiCalculator_form_inputActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputEnterActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputEnterMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputEnterAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_roiButton } from "./en-US.js"

export { roiCalculator_form_inputPrefix } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { organisms_pricing_rates_regionItlay_regionName } from "./en-US.js"

export { organisms_forms_legal_marketingCommunicationsConsent } from "./en-US.js"

export { organisms_forms_legal_agreeToTermsOfService } from "./en-US.js"

export { organisms_forms_legal_agreeTermsLinkText } from "./en-US.js"

export { organisms_forms_legal_agreeToPartnerCodeOfConduct } from "./en-US.js"

export { organisms_forms_legal_codeOfConduct_href } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_richTextBody } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_headline } from "./en-US.js"

export { helpCenter_templates_search_results } from "./en-US.js"

export { academy_courseStatus_registed } from "./en-US.js"